import { ClientProps } from '@/interfaces/models/client';
import Client from '@/models/client';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((clientPropsList: ClientProps[]): Client[] => {
      return clientPropsList.map(Client.createFromRequest);
    });
  }
};
